import React, { Component } from "react";
import { profile, GET, PUT, alert, loading } from "./CustomComponent.js";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import LOGO from "../assets/images/logo-w.png";
import "../assets/css/bootstrap.css";
export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  } 
  componentDidMount = async () => {};
  render() {
    return (
      <div className="w-100 px-5 py-2 bg-primary text-white d-flex flex-wrap justify-content-between">
        <span className="text-nowrap">SwiftGamePay</span>
        <div className="d-flex flex-wrap gap-3">
        <a className="text-white text-decoration-none text-nowrap" href="/policy-privacy">
          Privacy Policy
        </a>
        <a
          className="text-white text-decoration-none text-nowrap"
          href="mailto:swiftgamepay@gmail.com"
        >
          ติดต่อ : swiftgamepay@gmail.com
        </a>
        <a
          className="text-white text-decoration-none text-nowrap"
          href="tel:092-981-1596"
        >
          เบอร์โทร : 092-981-1596
        </a>
        </div>
      </div>
    );
  }
}
